import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "47",
  viewBox: "0 0 48 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(" .active { --fill-color: #FFA800; --stroke-color: #fff; } ")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("rect", {
      width: "48",
      height: "47",
      rx: "23.5",
      fill: "var(--fill-color, #E6E6E6)"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M15.855 31.1611C15.855 31.1611 15.945 31.1611 15.9787 31.1611L19.275 30.8573C19.7363 30.8123 20.1637 30.6098 20.49 30.2836L32.9325 17.8411C33.5175 17.2561 33.8438 16.4798 33.8438 15.6586C33.8438 14.8373 33.5175 14.0611 32.9325 13.4761L32.1337 12.6773C30.9637 11.5073 28.9275 11.5073 27.7575 12.6773L26.1713 14.2636L15.3263 25.1086C15 25.4348 14.7975 25.8623 14.7638 26.3236L14.46 29.6198C14.4262 30.0361 14.5725 30.4411 14.865 30.7448C15.135 31.0148 15.4838 31.1611 15.855 31.1611ZM29.9513 13.4536C30.3113 13.4536 30.6712 13.5886 30.9412 13.8698L31.74 14.6686C32.01 14.9386 32.1562 15.2873 32.1562 15.6586C32.1562 16.0298 32.01 16.3898 31.74 16.6486L30.75 17.6386L27.9713 14.8598L28.9613 13.8698C29.2313 13.5998 29.5913 13.4536 29.9513 13.4536ZM16.44 26.4811C16.44 26.4136 16.4738 26.3573 16.5187 26.3123L26.7675 16.0523L29.5462 18.8311L19.2975 29.0798C19.2975 29.0798 19.185 29.1586 19.1287 29.1586L16.17 29.4286L16.44 26.4698V26.4811ZM36.0938 34.7498C36.0938 35.2111 35.7113 35.5936 35.25 35.5936H12.75C12.2887 35.5936 11.9062 35.2111 11.9062 34.7498C11.9062 34.2886 12.2887 33.9061 12.75 33.9061H35.25C35.7113 33.9061 36.0938 34.2886 36.0938 34.7498Z",
      fill: "var(--stroke-color, #353535)"
    }, null, -1))
  ]))
}
export default { render: render }